import { render, staticRenderFns } from "./ConfigNav.vue?vue&type=template&id=10d7d335&scoped=true&"
import script from "./ConfigNav.vue?vue&type=script&lang=js&"
export * from "./ConfigNav.vue?vue&type=script&lang=js&"
import style0 from "./ConfigNav.vue?vue&type=style&index=0&id=10d7d335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7d335",
  null
  
)

export default component.exports